function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M3.805 11.145c-.997.472-.91.955.192 1.077l6.506.723c.275.03.522.277.552.552l.723 6.506c.123 1.103.609 1.18 1.077.192l7.29-15.39c.472-.997.039-1.418-.95-.95z"
}));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/location/ic-curr-loc.svg";
export { SvgComponent as ReactComponent };